// import { GENERATE_URL } from "./helpers/request.js";

import Account from "./Account";
import Admin from "./Admin";
import Battery from "./Battery";
import BatteryFeatures from "./BatteryFeatures";
import Project from "./Project";
import FinPitches from "./FinPitches";
import Geometry from "./Geometry";
import Materials from "./Materials";
import Refrigerants from "./Refrigerants";
import Thicknesses from "./Thicknesses";
import BatteryPermissions from "./BatteryPermissions";
import CompressorBrands from "./CompressorBrands";
import CompressorBrandRefrigerants from "./CompressorBrandRefrigerants";
import CompressorRefrigerantModels from "./CompressorRefrigerantModels";
import ProjectPermissions from "./ProjectPermissions";
import MainProject from "./MainProject";
import Series from "./Series";
import Cycle from "./Cycle";
import CycleParameters from "./CycleParameters";
import CyclePermissions from "./CyclePermissions";
import AuthorityDepartmentUser from "./AuthorityDepartmentUser";
import Department from "./Department";
import DepartmentUser from "./DepartmentUser";
import ProjectFileLog from "./ProjectFileLog";
import CraneHVACC from "./CraneHVACC";
import HeatGain from "./HeatGain";
import ProjectTag from "./ProjectTag";
import ProjectMainProject from "./ProjectMainProject";
import Tks from "./Tks";
import AuxiliaryCoolingEquipment from "./AuxiliaryCoolingEquipment";
import ProjectAuxiliaryCoolingEquipment from "./ProjectAuxiliaryCoolingEquipment";
import TechinalDrawing from "./TechinalDrawing";

export default {
  Account,
  Admin,
  Battery,
  BatteryFeatures,
  Cycle,
  Project,
  FinPitches,
  Geometry,
  Refrigerants,
  Materials,
  Thicknesses,
  BatteryPermissions,
  CompressorBrands,
  CompressorBrandRefrigerants,
  CompressorRefrigerantModels,
  ProjectPermissions,
  MainProject,
  Series,
  CycleParameters,
  CyclePermissions,
  AuthorityDepartmentUser,
  Department,
  DepartmentUser,
  ProjectFileLog,
  CraneHVACC,
  HeatGain,
  ProjectTag,
  ProjectMainProject,
  Tks,
  AuxiliaryCoolingEquipment,
  ProjectAuxiliaryCoolingEquipment,
  TechinalDrawing,
};
